import { createSelector } from "@reduxjs/toolkit";

import { getNodeSlotIdSelector, nodeIdParamSelector } from "@skilitics/nautilus-core-designer-data";

import { getParentContextByIdCreate } from "../getNodeParentContext.ts";
import { getManifestSelector, rootNodeParentContextSelector } from "./appConfigSelectors.ts";
import { getMonolingualDesignerNodeDataSelector } from "./nodeConfigSelectors.ts";
import { getNodeProfileByIdSelector } from "./profileSelectors.ts";

export const getParentContextByIdSelector = createSelector(
  getManifestSelector,
  rootNodeParentContextSelector,
  getNodeSlotIdSelector,
  getMonolingualDesignerNodeDataSelector,
  getNodeProfileByIdSelector,
  (getManifest, rootNodeParentContext, getNodeSlotId, getMonolingualDesignerNodeData, getNodeProfileById) =>
    getParentContextByIdCreate(
      getManifest,
      getMonolingualDesignerNodeData,
      getNodeSlotId,
      rootNodeParentContext,
      getNodeProfileById,
    ),
);

export const parentContextSelector = createSelector(
  getParentContextByIdSelector,
  nodeIdParamSelector,
  (getParentContextById, nodeId) => getParentContextById(nodeId),
);
